// import all the custom js files here

// Scripts with conditionally called functions (and NOT to be imported dynamically/conditionally)
import './js/bracelets-overview';
import './js/mobile-shop';
import './js/brand-ambassador';
import './js/free-bracelet';
import './js/product-bracelet-pwyw';

// Scripts with IIF
import themeScript from './js/theme';
import footerNewsletterScript from './js/footer-newsletter';
import headerScript from './js/header';

themeScript();
footerNewsletterScript();
headerScript();

// Scripts that should be dynamically loaded (based on `shouldImport` condition)
const bodyClassList = document.body.classList;
const conditionalImports = [
  {
    shouldImport: document.querySelector('.partnerships-logo__container'),
    loader: () => import('./js/partnership-logos'),
  },
  {
    shouldImport: document.querySelector('.animal-missions__wrapper'),
    loader: () => import('./js/animal-carousel'),
  },
  {
    shouldImport:
      bodyClassList.contains('template-product-default') || bodyClassList.contains('template-product-plush'),
    loader: () => import('./js/product-default-carousel'),
  },
  {
    shouldImport: bodyClassList.contains('template-product-common'),
    loader: () => import('./js/product-common-carousel'),
  },
  {
    shouldImport:
      bodyClassList.contains('template-product-bracelets') || bodyClassList.contains('template-product-bracelets-pwyw'),
    loader: () => import('./js/product-bracelets-carousel'),
  },
  {
    shouldImport: bodyClassList.contains('template-product-bracelets-multi-species'),
    loader: () => import('./js/product-bracelets-multi-carousel'),
  },
  {
    shouldImport: bodyClassList.contains('page-type-collection'),
    loader: () => import('./js/collection-filter'),
  },
  {
    shouldImport: bodyClassList.contains('page-type-index'),
    loader: () => import('./js/home-hero-slider'),
  },
  {
    shouldImport: document.querySelector('.featured-carousel__container'),
    loader: () => import('./js/featured-carousel'),
  },
  {
    shouldImport: document.querySelector('.accordion'),
    loader: () => import('./js/accordion'),
  },
  {
    shouldImport: document.querySelector('.collection-buttons__wrapper'),
    loader: () => import('./js/collections-buttons'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-wholesale-program-2'),
    loader: () => import('./js/wholesale-page'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-wholesale-program-2'),
    loader: () => import('./js/wholesale-page-form'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/partner-page'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/partner-page-form'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/testimonials'),
  },
  {
    shouldImport: document.querySelector('.accordion-content__wrapper ul li'),
    loader: () => import('./js/accordion-list-item-layout'),
  },
];

conditionalImports.forEach(({ shouldImport, loader }) => {
  if (shouldImport) {
    loader()
      .then((module) => {
        module.default();
      })
      .catch((err) => {
        console.error(`Error executing ${loader}`, err);
      });
  }
});
